// import {} from
function getCascaderValue(ids, list) {
    let result = [];
    let multiResult = [];
    let tempList = list;
    ids.forEach((id) => {
        if (id instanceof Array) {
            multiResult.push(getCascaderValue(id, list));
        } else {
            let target = tempList.find((item) => {
                return item.value == id;
            });
            if (target) {
                result.push(target.label);
                tempList = target.children;
            }
        }

    });
    return result.length > 0 ? result.join("/") : multiResult.join("，");
};

function getShowValue(info, value) {
    let { compType } = info;
    if (info.options && info.options.length > 0) {  //下拉的
        if (compType == "cascader") {   //级联的
            return getCascaderValue(value, info.options);
        } else {//其他下拉

            if (value instanceof Array) {
                let resultStr = value.reduce((pre, curFlag, index) => {
                    let target = info.options.find((item) => {
                        return item.value == curFlag;
                    });
                    if (target) {
                        pre = index == 0 ? target.label : pre + "," + target.label;
                    }
                    return pre;
                }, "");
                return resultStr;
            } else {
                let target = info.options.find((item) => {
                    return item.value == value;
                });
                return target.label;
            };

        };
    } else {
        return value;
    };
};

export { getCascaderValue, getShowValue };